import { ReactNode, memo } from "react";
import { Box, SxProps, Theme } from "@mui/material";

interface ExpandToFullScreenProps {
  isExpanded: boolean;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const ExpandToFullScreen = memo(
  ({ isExpanded, children, sx }: ExpandToFullScreenProps) => (
    <Box
      sx={{
        ...(isExpanded
          ? {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100vw",
              height: "100vh",
              zIndex: (theme) => theme.zIndex.tooltip + 1,
              backgroundColor: "background.paper",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }
          : {
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }),
        ...sx,
      }}
    >
      {children}
    </Box>
  )
);
